export const FETCH_ANALYZE_RANGE = '[ANALYZE]FETCH_ANALYZE_RANGE';
export const FETCH_STAFF_ANALYZE_RANGE = '[ANALYZE]FETCH_STAFF_ANALYZE_RANGE';

export const FETCH_STAFF_TIP_RANGE = '[ANALYZE]FETCH_STAFF_TIP_RANGE';
